export default __webpack_public_path__ + "static/media/rohit.96bc4f46.jfif";